/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { MENU_WIDTH } from '../constants';
import { getNotificationSentLog } from '../store/actions/history';
import NotificationLogFilterPanel from '../components/NotificationLogFilterPanel';

const columns = [
  {
    id: 'target_arn',
    label: 'Target ARN',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'message',
    label: 'Message',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'message_id',
    label: 'Message ID',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'created_at',
    label: 'Created At',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'error_msg',
    label: 'Error Message',
    minWidth: 170,
    align: 'center',
  },
];

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    paddingLeft: MENU_WIDTH,
    paddingTop: '6rem',
    height: '100%',
  },
  paper: {
    margin: '2em',
  },
  content: {
    flexGrow: 1,
    borderRadius: 4,
  },
  table: {
    width: '100%',
  },
  headerCell: {
    backgroundColor: '#526488',
    fontWeight: 'bold',
    textAlign: 'center',
    color: 'white',
  },
  top: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '2rem 2rem 0 2rem',
  },
}));

const NotificationLog = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const notificationRecords = useSelector((state) => state.history.notificationRecords || []);
  const notificationRecordsCount = useSelector((state) => state.history.notificationRecordsCount || 0);
  const [displayList, setDisplayList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const classes = useStyles();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => { 
    dispatch(getNotificationSentLog(id, [], page + 1, rowsPerPage));
  }, [id]);  
  
  useEffect(() => {
    setDisplayList((prevList) => {
      const newList = notificationRecords.map((row) => {
        // Find the user by ID
        return {
          target_arn: row.target_arn,
          message: row.message,
          message_id: row.message_id,
          created_at: row.created_at,
          error_msg: row.error_message,
        };
      });  
  
      // Only update state if newList is actually different
      return JSON.stringify(prevList) === JSON.stringify(newList) ? prevList : newList;
    });
  }, [notificationRecords]);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
    dispatch(getNotificationSentLog(id, newPage + 1, rowsPerPage));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    dispatch(getNotificationSentLog(id, 1, +event.target.value));
  };

  const onFiltersChanged = (filters) => {
    setStartDate(filters.start);
    setEndDate(filters.end);
    dispatch(getNotificationSentLog(id, page + 1, rowsPerPage, filters.start, filters.end));
  };

  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <NotificationLogFilterPanel onChange={onFiltersChanged} />
      </div>
      <Paper className={classes.paper}>
        <TableContainer className={classes.content}>
          <Table stickyHeader aria-label="sticky table" className={classes.table}>
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    className={classes.headerCell}
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {displayList.map((row, index) => {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <TableRow className={classes.row} hover key={index}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align} className={classes.cell}>
                          {column.format ? column.format(value, row) : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={notificationRecordsCount || 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
};

export default NotificationLog;
